export enum PlatformEnum {
  WEB = 'web',
  IOS_STAFF = 'ios-staff',
  IOS_PRIVATE = 'ios-private',
  ANDROID_STAFF = 'android-staff',
  ANDROID_PRIVATE = 'android-private',
}
